import { styled } from "styled-components";

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2.5rem;
  margin-top: 2.5rem;
  height: 100%;
`;
